// @ts-nocheck
import * as $ from 'jquery';
import * as signalR from '@microsoft/signalr';

$(async () => {

    let $statusProgress = $('#status-progress');
    let $statusProgressText = $('#status-progress-text');
    let $globalInformation = $('#global-import-information');
    let $globalStatusProgress = $('#global-import-status-progress');

    setVisibility();

    let status = {
        progressPercent: 0,
        currentActivity: 'None',
        isCompleted: false,
        nextActivity: ''
    };
    const jobData = getJobData();
    if (!jobData) return;

    const connection = new signalR.HubConnectionBuilder()
        .withUrl("/employee-import-status")
        .configureLogging(signalR.LogLevel.Information)
        .build();

    connection.onclose(async () => {
        await start();
    });

    connection.on('StatusUpdated', (data) => {
        statusUpdated(data);
    });

    await start();
    await register();

    async function start() {
        try {
            await connection.start();
            console.log("SignalR Connected.");
        } catch (err) {
            console.log(err);
            setTimeout(start, 5000);
        }
    }

    async function register() {
        try {
            await connection.invoke("Register", {organizationId: jobData.organizationId});
        } catch (err) {
            console.error(err);
        }
    }

    function setVisibility() {
        if (isImportPage()) {
            $globalInformation.addClass('d-none');
        }
    }

    function isImportPage() {
        return !!$statusProgress.length;
    }

    function statusUpdated(data) {
        // We are listening to all organization jobs, so filter out the ones that we are not interested
        if (data.jobId != jobData.jobId) return;

        status = data;
        updateStatusProgress();
        updateStatusProgressText();
        updateGlobalStatusProgress();
        checkCompleted();
    }

    function updateStatusProgress() {
        updateProgress($statusProgress, status.progressPercent, status.currentActivity);
    }

    function updateStatusProgressText() {
        const displayName = translateActivity(status.nextActivity);
        const text = !displayName ? '' : `${displayName}...`;
        $statusProgressText.text(text);
    }

    function updateGlobalStatusProgress() {
        updateProgress($globalStatusProgress, status.progressPercent, status.currentActivity);
    }

    function updateProgress($element, percent, currentActivity) {
        $element.attr('aria-valuenow', percent);
        $element.width(`${percent}%`);
        $element.text(`${percent}%`)

        if (currentActivity == 'Error') {
            $element
                .removeClass('bg-success')
                .addClass('bg-danger');
        }
    }

    function checkCompleted() {
        if (status.isCompleted && isImportPage()) {
            location.reload();
        }
    }

    function getJobData() {
        let value = $('[name="job-data"]').val();
        if (!value) return null;
        return JSON.parse(value);
    }

    function translateActivity(activity) {
        // @ts-ignore
        const translations = window.jsl10n.Kolumbus.Skynet.AdminPages.Features.ImportJobs.EmployeeImportActivity;
        return translations[activity];
    }
});